module.exports = __webpack_public_path__ + "static/img/logo.bc7543b1.png";